import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Config } from '../config';
import { ValidationInputData, TicketRate } from '../models';
import { map } from 'rxjs/operators';

@Injectable()
export class TicketService {

    ticketRate: TicketRate;

    constructor(
        private config: Config,
        private http: HttpClient
    ) { }

    findByPartTicketNumber(id: string): Observable<Array<string>> {
        return this.http.get<Array<string>>(this.config.get('API_SERVER_URL') + `/validation/ticketNumberList?inputNumber=${id}`);
    }

    chargeValue(ticket: string): Observable<TicketRate> {
        return this.http.get<TicketRate>(this.config.get('API_SERVER_URL') + `/validation/chargeValue/${ticket}`);
    }

    getValidationConfigs(): Observable<Array<any>> {
        return this.http.get<Array<any>>(this.config.get('API_SERVER_URL') + '/validation/validationConfigs');
    }

    validateTicket(validationInputData: ValidationInputData): Observable<HttpResponse<void>> {
        return this.http.post<HttpResponse<void>>(this.config.get('API_SERVER_URL') + '/validation/validate', validationInputData);
    }
}
